import {
  always,
  anyPass,
  chain,
  converge,
  filter,
  identity,
  isEmpty,
  isNil,
  join,
  map,
  pipe,
  prop,
  unapply,
} from "ramda";
import { of } from "most";
import { debounce, mergeArray, recoverWith, until } from "common/mostCurried";
import { tap } from "common/general";
import { combineEpics, select, selectArray, withState } from "redux-most";
import * as steps from "common/steps";
import * as applicationActions from "application/applicationActions";
import * as submissionActions from "./submissionActions";
import mapSubmissionData from "./mapSubmissionData";
import { uploadSubmission } from "common/stipAjax";
import {
  fetchFromLocalStorage,
  removeObjectFromLocalStorage,
  saveToLocalStorage,
} from "common/localStorageHelpers";
import {
  getActiveStep,
  getWorkType,
  getSubmissionFiles,
  doesStepHaveErrors,
  getNextIncompleteStep,
  getOrganizationAlias,
  getProjectId,
  getProjectKey,
  getProjectRedirectUri,
} from "common/selectors";

const getSubmissionFormData = (state) => {
  console.log(state);
  const submissionData = mapSubmissionData(state);
  console.log("Submission data >>>>>>>>>>>>>>>>>>>>>>");
  console.log(submissionData);

  const submissionBlob = new Blob([JSON.stringify(submissionData)], {
    type: "application/json",
  });

  const formData = new FormData();
  formData.append("submission-data", submissionBlob);

  return formData;
};

const createKey = pipe(
  converge(unapply(identity), [
    getProjectKey,
    getOrganizationAlias,
    always("submission"),
  ]),
  filter(identity),
  join("-")
);

export const acknowledgeSubmissionEpic = (action$, state$) =>
  pipe(
    select(submissionActions.ACKNOWLEDGE_SUBMISSION_COMPLETE),
    withState(state$),
    chain(([state, action]) =>
      pipe(
        createKey,
        removeObjectFromLocalStorage,
        map(() => {
          const redirectUri = getProjectRedirectUri(state);

          if (!isNil(redirectUri) && !isEmpty(redirectUri)) {
            window.location.href = redirectUri;
            return submissionActions.localStorageSynced();
          } else {
            return submissionActions.cancelSubmission();
          }
        })
      )(state)
    )
  )(action$);

const saveSubmissionToLocalStorage = converge(
  (key, activeStep, submissionFiles, workTypeId) =>
    saveToLocalStorage(key, { activeStep, workTypeId, submissionFiles }),
  [createKey, getActiveStep, getSubmissionFiles, pipe(getWorkType, prop("id"))]
);

const loadLocalStorageEpic = (action$, state$) =>
  pipe(
    select(applicationActions.APP_DATA_LOADED),
    withState(state$),
    chain(([state, action]) =>
      pipe(
        createKey,
        fetchFromLocalStorage,
        map(submissionActions.localStorageLoaded),
        recoverWith(pipe(applicationActions.appError, of))
      )(state)
    )
  )(action$);

const syncLocalStorageEpic = (action$, state$) =>
  pipe(
    selectArray([
      submissionActions.ADD_ANOTHER_WORK,
      submissionActions.CANCEL_SUBMISSION,
      submissionActions.SET_ACTIVE_STEP,
      submissionActions.SET_WORK_TYPE_ID,
      submissionActions.SUBMIT,
      submissionActions.SET_SUBMISSION_FILES,
      submissionActions.UPDATE_SUBMISSION_FILES,
    ]),
    withState(state$),
    debounce(200),
    chain(([state, action]) =>
      pipe(
        saveSubmissionToLocalStorage,
        map(submissionActions.localStorageSynced),
        recoverWith(pipe(applicationActions.appError, of))
      )(state)
    )
  )(action$);

const sendSubmissionEpic = (action$, state$) =>
  pipe(
    select(submissionActions.SEND_SUBMISSION),
    withState(state$),
    chain(([state, action]) =>
      pipe(
        converge(uploadSubmission, [getSubmissionFormData, getProjectId]),
        ([request$, progress$]) => [
          map(submissionActions.uploadComplete, request$),
          map(
            (e) =>
              submissionActions.uploadProgress(
                "Metadata",
                Math.floor((e.loaded / e.total) * 100)
              ),
            progress$
          ),
        ],
        mergeArray,
        until(select(submissionActions.CANCEL_UPLOAD, action$)),
        recoverWith(pipe(applicationActions.appError, of))
      )(state)
    )
  )(action$);

const hasErrors = anyPass([
  doesStepHaveErrors(steps.TERMS),
  doesStepHaveErrors(steps.FILE_UPLOAD),
  doesStepHaveErrors(steps.FILE_DETAILS),
  doesStepHaveErrors(steps.BASIC_DETAILS),
]);

const submitEpic = (action$, state$) =>
  pipe(
    select(submissionActions.SUBMIT),
    withState(state$),
    tap(() => window.scrollTo(0, 0)),
    map(([state, action]) =>
      hasErrors(state)
        ? submissionActions.invalidSubmission(getNextIncompleteStep(state))
        : submissionActions.sendSubmission()
    )
  )(action$);

export default combineEpics([
  acknowledgeSubmissionEpic,
  loadLocalStorageEpic,
  sendSubmissionEpic,
  submitEpic,
  syncLocalStorageEpic,
]);
